// Width of the reservation form column: 95 spacing steps, 380 px. It keeps the width the form had
// as one third of the large dialog (378 px), so in the xLarge dialog the datagrid gets the rest.
export const RESERVATION_INFO_WIDTH = 95;
